/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { ApolloError } from '@apollo/client/errors';

import { OptionType } from '../../src/components/DropdownSelects';

export function formatPhoneNumberInput(phoneNumberInput: string): string {
  if (!phoneNumberInput) {
    return '';
  }
  const cleansedPhoneNumber = cleansePhoneNumber(phoneNumberInput);
  const p1 = cleansedPhoneNumber.substring(0, 3);
  const p2 = cleansedPhoneNumber.substring(3, 6);
  const p3 = cleansedPhoneNumber.substring(6, 10);

  const fragments = [
    p1.length > 0 ? '(' : '',
    p1,
    p2.length > 0 ? ') ' : '',
    p2,
    p3.length > 0 ? '-' : '',
    p3,
  ];

  return fragments.join('');
}

export function cleansePhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) {
    return '';
  }
  let cleansedPhoneNumber = phoneNumber.replace(/\D/g, '');
  // real phone numbers never have area codes starting with 1, but our fake numbers on staging do
  if (cleansedPhoneNumber[0] === '1' && cleansedPhoneNumber.length > 10) {
    cleansedPhoneNumber = cleansedPhoneNumber.substring(1, 11);
  } else {
    cleansedPhoneNumber = cleansedPhoneNumber.substring(0, 10);
  }
  return cleansedPhoneNumber;
}

export function centsToCurrencyString(valueCents: number, roundToCents = false) {
  const dollars = valueCents / 100;
  const showNegative = roundToCents ? dollars <= -0.005 : dollars <= -0.5;
  const dollarsString = Math.abs(dollars).toLocaleString('en-US', {
    maximumFractionDigits: roundToCents ? 2 : 0,
  });
  return `${showNegative ? '-' : ''}$${dollarsString}`;
}

export function dollarsToCurrencyString(valueDollars: number, roundToCents = false) {
  const showNegative = roundToCents ? valueDollars <= -0.005 : valueDollars <= -0.5;
  const dollarsString = Math.abs(valueDollars).toLocaleString('en-US', {
    maximumFractionDigits: roundToCents ? 2 : 0,
  });
  return `${showNegative ? '-' : ''}$${dollarsString}`;
}

export const datesToTrimmedDates = ({
  startDate,
  endDate,
}: {
  startDate: Date;
  endDate: Date;
}): { startDate: string; endDate: string } => {
  const dateToString = (date: Date) => new Date(date.toDateString()).toISOString();

  const dateParams = {
    startDate: dateToString(startDate!),
    endDate: dateToString(endDate!),
  };

  return dateParams;
};

export const datesToParams = ({
  startDate,
  endDate,
}: {
  startDate: Date;
  endDate: Date;
}): { startDate: string; endDate: string } => {
  const dateToString = (date: Date) => date.toISOString().split('T')[0];

  const dateParams = {
    startDate: dateToString(startDate!),
    endDate: dateToString(endDate!),
  };

  return dateParams;
};

export const optionToDates = (option: string) => {
  let startDate: Date;
  const today = new Date();

  switch (option) {
    case 'monthToDate':
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      break;
    case 'yearToDate':
      startDate = new Date(new Date().getFullYear(), 0, 1);
      break;
    case 'lastyear':
      startDate = new Date();
      startDate.setFullYear(startDate.getFullYear() - 1);
      break;
    case 'last2years':
      startDate = new Date();
      startDate.setFullYear(startDate.getFullYear() - 2);
      break;
    case 'last90':
      startDate = new Date(new Date().setDate(today.getDate() - 90));
      break;
    case 'sinceInception':
      startDate = new Date(2014, 0);
      break;
    default:
    case 'last30':
      startDate = new Date(new Date().setDate(today.getDate() - 30));
      break;
  }

  return { startDate, endDate: today };
};

export const sortRegionsByDisplayName = (a: OptionType, b: OptionType): number => {
  if (a.label < b.label) {
    return -1;
  }
  return 1;
};

export const getErrorMessage = (error: ApolloError) => {
  return error.message.replace('GraphQL error:', ' ').trim();
};

export const formatPercentage = (value: number) => {
  return `${Math.round(value * 100)}%`;
};

export const isNullDateString = (date: string) => {
  if (date === '0001-01-01T00:00:00.000Z') {
    return true;
  }

  const dateObj = new Date(date);
  const timeMs = dateObj.getTime();
  if (isNaN(timeMs)) {
    return true;
  }
  return timeMs === 0;
};
